module.exports = __webpack_public_path__ + "img/logo_preto.8ef8451a.png";